/* =====================================================================
   PONTE AUTOMÁTICA (por tag) — Add to cart / Shopify Payments
   MULTI-PAÍS (Alemanha, Áustria, Luxemburgo, Suíça) numa loja só
   ---------------------------------------------------------------------
   Sem Releasit, sem formulário, sem carrinho: ao clicar em comprar,
   cria o carrinho na Loja B com o produto mapeado e manda direto pro
   checkout — no mercado/idioma do país detectado do visitante.

   Mapa de produtos: automático por tag rma#/rmb# (lê o products.json).
   País de destino: detectado do mercado atual da Loja A.

   Pré-requisitos:
     - Loja A roda os 4 países via Shopify Markets (DE/AT/LU/CH)
     - Produtos taguados rma#/rmb# nas duas lojas
     - Mercados DE/AT/LU/CH ativos na Loja B, com produtos publicados
     - IMPORTANTE: mercado CH (Suíça) em CHF; DE/AT/LU em euro
   ===================================================================== */
(function () {
  "use strict";

  // ===================== CONFIG =====================
  const SHOP_A = "";  // "" usa a própria loja atual; ou ex.: "https://loja-a.myshopify.com"
  const API_B  = "https://xw1pen-0d.myshopify.com/api/2025-07/graphql.json";
  const SHOP_B = "https://xw1pen-0d.myshopify.com";
  const STOREFRONT_TOKEN = "02a5d76e49939e54488889ea92ae3db1"; // token PÚBLICO da Loja B

  // Mercados que esta loja atende: país (enum) -> idioma (enum) do checkout
  const MARKETS = {
    DE: { language: "DE" },  // Alemanha  (EUR)
    AT: { language: "DE" },  // Áustria   (EUR)
    LU: { language: "DE" },  // Luxemburgo (EUR)
    CH: { language: "DE" },  // Suíça     (CHF — configurar moeda no mercado da Loja B)
  };
  const PAIS_FALLBACK = "DE"; // usado só se a detecção falhar

  // Seletor do botão de compra (ajustar se o tema usar outro)
  const ADD_SELECTOR = 'button[name="add"], [type="submit"][name="add"]';

  const TAG_RE = /^rm[ab](\d+)$/i;
  // =================================================

  let emAndamento = false;
  const val = (sel) => document.querySelector(sel)?.value?.trim() || "";

  // ---- Detecta o país do mercado atual do visitante -------------------
  function detectarPais() {
    // 1) global da Shopify (presente em lojas com Markets)
    let c = (window.Shopify && Shopify.country) ? String(Shopify.country).toUpperCase() : "";
    // 2) cookie de localização
    if (!MARKETS[c]) {
      const m = document.cookie.match(/(?:^|;\s*)localization=([A-Za-z]{2})/);
      if (m) c = m[1].toUpperCase();
    }
    // 3) prefixo de locale na URL (ex.: /en-gb, /es, /de, /fr)
    if (!MARKETS[c]) {
      const seg = (location.pathname.split("/")[1] || "").split("-");
      const region = (seg[1] || seg[0] || "").toUpperCase();
      if (MARKETS[region]) c = region;
    }
    return MARKETS[c] ? c : PAIS_FALLBACK;
  }

  // ---- Mapa automático por tag (cache) -------------------------------
  async function indexarPorTag(baseUrl) {
    const idx = {};
    for (let page = 1; page <= 20; page++) {
      const r = await fetch(`${baseUrl || ""}/products.json?limit=250&page=${page}`, { credentials: "omit" })
        .then((x) => x.json());
      if (!r.products || !r.products.length) break;
      r.products.forEach((p) => {
        const tags = Array.isArray(p.tags) ? p.tags : String(p.tags || "").split(",");
        for (const t of tags) {
          const m = String(t).trim().match(TAG_RE);
          if (m && p.variants && p.variants[0]) { idx[m[1]] = String(p.variants[0].id); break; }
        }
      });
    }
    return idx;
  }

  let mapaPromise = null;
  async function getMapa() {
    if (!mapaPromise) {
      mapaPromise = (async () => {
        const [idxA, idxB] = await Promise.all([indexarPorTag(SHOP_A), indexarPorTag(SHOP_B)]);
        const mapa = {};
        for (const num in idxA) {
          if (idxB[num]) mapa[idxA[num]] = idxB[num];
          else console.warn("[ponte] tag sem par na Loja B: rm*" + num);
        }
        console.log("[ponte] mapa por tag:", Object.keys(mapa).length, "pares");
        return mapa;
      })();
    }
    return mapaPromise;
  }
  getMapa(); // pré-carrega

  const gql = (query, variables) =>
    fetch(API_B, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN,
      },
      body: JSON.stringify({ query, variables }),
    }).then((r) => r.json());

  function formDoBotao(btn) {
    const formId = btn.getAttribute("form");
    return (formId && document.getElementById(formId)) || btn.closest("form");
  }

  async function transferir(btn) {
    try {
      const mapa = await getMapa();
      const form = formDoBotao(btn);
      const variantA = form?.querySelector('[name="id"]')?.value;
      const qty = parseInt(form?.querySelector('[name="quantity"]')?.value || "1", 10) || 1;

      const vB = variantA && mapa[variantA];
      if (!vB) { console.error("[ponte] produto A sem par por tag:", variantA); emAndamento = false; return; }

      const pais = detectarPais();
      const language = MARKETS[pais].language;
      console.log("[ponte] país:", pais, "| idioma:", language, "| variante B:", vB);

      const lines = [{ merchandiseId: `gid://shopify/ProductVariant/${vB}`, quantity: qty }];

      const c = await gql(
        `mutation($input: CartInput!, $country: CountryCode!, $language: LanguageCode!)
           @inContext(country: $country, language: $language) {
           cartCreate(input: $input) { cart { id checkoutUrl } userErrors { field message } }
         }`,
        { input: { lines }, country: pais, language }
      );
      const cart = c?.data?.cartCreate?.cart;
      if (!cart) { console.error("[ponte] cartCreate falhou:", c?.data?.cartCreate?.userErrors || c); emAndamento = false; return; }

      console.log("[ponte] indo para:", cart.checkoutUrl);
      window.location.href = cart.checkoutUrl;
    } catch (err) {
      console.error("[ponte] erro inesperado:", err);
      emAndamento = false;
    }
  }

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(ADD_SELECTOR);
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (emAndamento) return;
    emAndamento = true;
    transferir(btn);
  }, true);

  console.log("[ponte] script AUTO multi-país carregado. mercados:", Object.keys(MARKETS).join(","));
})();